import { isClient } from './isClient.js';

var getScrollbarSize = (function () {
    var cachedSize;
    return function () {
        if (cachedSize !== undefined)
            return cachedSize;
        if (!isClient())
            return 0;
        var scrollDiv = document.createElement('div');
        scrollDiv.style.width = '99px';
        scrollDiv.style.height = '99px';
        scrollDiv.style.position = 'absolute';
        scrollDiv.style.top = '-9999px';
        scrollDiv.style.overflow = 'scroll';
        document.body.appendChild(scrollDiv);
        var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        cachedSize = scrollbarSize;
        return scrollbarSize;
    };
})();
function isWebkitBased() {
    if (!isClient())
        return false;
    return window.navigator.userAgent.toLowerCase().indexOf('webkit') > -1;
}
var browser = {
    getScrollbarSize: getScrollbarSize,
    isWebkitBased: isWebkitBased,
};

export { browser };
